'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$CtaSection(title, sub, primary, secondary) {
  this.ic = null;
  this.ib = null;
  this.go = null;
  this.gp = null;
  this.ic = title;
  this.ib = sub;
  this.go = primary;
  this.gp = secondary;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$CtaSection as $c_Lio_intela_sites_digitalinternship_data_Segments$CtaSection };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$CtaSection.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$CtaSection;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$CtaSection() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$CtaSection as $h_Lio_intela_sites_digitalinternship_data_Segments$CtaSection };
$h_Lio_intela_sites_digitalinternship_data_Segments$CtaSection.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, (-703012010), true);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$CtaSection)) {
    if (((this.ic === x$0.ic) && (this.ib === x$0.ib))) {
      var x = this.go;
      var x$2 = x$0.go;
      var $x_1 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.gp;
      var x$4 = x$0.gp;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 4;
});
$p.I = (function() {
  return "CtaSection";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.ic;
      break;
    }
    case 1: {
      return this.ib;
      break;
    }
    case 2: {
      return this.go;
      break;
    }
    case 3: {
      return this.gp;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$CtaSection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bx)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$CtaSection as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$CtaSection };
var $d_Lio_intela_sites_digitalinternship_data_Segments$CtaSection = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$CtaSection, "io.intela.sites.digitalinternship.data.Segments$CtaSection", ({
  bx: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$CtaSection as $d_Lio_intela_sites_digitalinternship_data_Segments$CtaSection };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Cta-Section.js.map
